import React from 'react';
import { get, isEmpty, set } from 'lodash';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { Field, Form, formValueSelector, reduxForm, submit } from 'redux-form';

import { logLeaveQuoteReason } from '../../policy/redux/policyActions';
import { Modal } from 'react-bootstrap';
import { LeavingSelectField } from '../../../common/components/ReduxFormField';
import { Button } from '../../../common/components';
const leavingOptions = [
  { label: 'Call disconnected', value: 'Call disconnected' },
  {
    label: 'Customer did not wish to proceed with quote',
    value: 'Customer did not wish to proceed',
  },
  {
    label: 'Customer unable to provide required information',
    value: 'Customer unable to provide required information',
  },
  {
    label: 'Unable to offer annual quote',
    value: 'Unable to offer annual quote',
  },
  { label: 'Incorrect source', value: 'Incorrect source' },
  {
    label: 'Other (please email management with the reason)',
    value: 'Other (please email management with the reason)',
  },
];
const FORM_NAME = 'myLeaving';
const LeavingContainer = ({ next, dispatch, handleSubmit, handleClose, mta }) => {
  const handleLeave = (resource) => {
    if (!isEmpty(resource)) {
      const nextWithState = {
        ...next,
        state: {
          leaveConfirmed: true,
        },
      };
      dispatch(logLeaveQuoteReason(resource.data.attributes, mta));

      dispatch(push(nextWithState));
    }
  };

  const handleSubmitLeave = () => {
    dispatch(submit(FORM_NAME));
  };

  return (
    <Modal show={!!next} onHide={handleClose}>
      <Modal.Header closeButton>Warning</Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit(handleLeave)}>
          <div className="row">
            <div className="col-xs-12">
              <div>
                <p>
                  You are about to leave without saving. Please continue editing to save,
                  or select a reason below for leaving.
                </p>
                <div className="leaving-quotes-reasons">
                  <Field
                    name="data.attributes.meta.reason"
                    component={LeavingSelectField}
                    inline
                    options={leavingOptions}
                  />
                </div>
              </div>
            </div>
          </div>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button
          className="pull-left settings-button"
          bsStyle="default"
          leftIcon="times"
          label="Close"
          handleClick={handleClose}
        />
        <Button
          className="btn-leave-quote"
          bsStyle="primary"
          size="sm"
          handleClick={handleSubmitLeave}
          label="Leave Quote"
        />
      </Modal.Footer>
    </Modal>
  );
};
const validate = (values) => {
  const errors = {};
  if (isEmpty(get(values, 'data.attributes.meta.reason'))) {
    set(
      errors,
      'data.attributes.meta.reason',
      'Please select a reason for leaving this quote.',
    );
  }

  errors._error = errors.metadata;
  return errors;
};
const form = reduxForm({
  form: FORM_NAME,
  destroyOnUnmount: false,
  validate,
})(LeavingContainer);

const selector = formValueSelector(FORM_NAME);
export default connect((state) => {
  const values = selector(state, 'data.id', 'data.attributes');
  return {
    initialValues: {
      data: {
        attributes: {
          meta: {
            reason: '',
          },
        },
      },
    },
    formValues: values,
  };
})(form);
